import { render } from "./badgeDanger.vue?vue&type=template&id=06b8ed62"
import script from "./badgeDanger.vue?vue&type=script&lang=js"
export * from "./badgeDanger.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__